// utils.js
import { getThemeStyles } from "Components/chartsLibrary/GMap/themes"

export const initMap = (
  setInfoWindow,
  setBounds,
  setIcons,
  setMap,
  primaryActionColor, // kept for signature compatibility — no longer used here
  theme,
  options,
  ref
) => {
  const opts = {
    ...options,
    styles: getThemeStyles(theme),
    // Disable native Google controls — replaced by ZoomControls.jsx
    zoomControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
  }

  if (ref?.current && window.google) {
    setMap(new window.google.maps.Map(ref?.current, opts))
    setInfoWindow(new window.google.maps.InfoWindow())
    setBounds(new window.google.maps.LatLngBounds())
    // setIcons({}) // legacy shape — hooks.js stops reading from this in Task 9
    setIcons({
      type1: {
        icon: {
          path: "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z",
          fillColor: primaryActionColor,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 0.065,
          origin: new window.google.maps.Point(270, 360),
          anchor: new window.google.maps.Point(270, 360),
        },
      },
      type2: {
        icon: {
          path: "M128 0h24H360h24V24 96H512V256H320 192 0V96H128V24 0zM0 288H192v64H320V288H512V480H0V288zM336 48H176V96H336V48z",
          fillColor: primaryActionColor,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 0.05,
          origin: new window.google.maps.Point(270, 360),
          anchor: new window.google.maps.Point(270, 360),
        },
      },
      type3: {
        icon: {
          path: "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z",
          fillColor: primaryActionColor,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 0.045,
          origin: new window.google.maps.Point(270, 360),
          anchor: new window.google.maps.Point(270, 360),
        },
      },
      type4: {
        icon: {
          path: "M224 64C206.3 64 192 78.3 192 96L192 128L160 128C124.7 128 96 156.7 96 192L96 240L544 240L544 192C544 156.7 515.3 128 480 128L448 128L448 96C448 78.3 433.7 64 416 64C398.3 64 384 78.3 384 96L384 128L256 128L256 96C256 78.3 241.7 64 224 64zM96 288L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 288L96 288z",
          fillColor: primaryActionColor,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 0.045,
          origin: new window.google.maps.Point(270, 360),
          anchor: new window.google.maps.Point(270, 360),
        },
      },
      type5: {
        icon: {
          path: "M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z",
          fillColor: primaryActionColor,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 0.045,
          origin: new window.google.maps.Point(270, 360),
          anchor: new window.google.maps.Point(270, 360),
        },
      },
    })
  }
}
